// eslint-disable-next-line no-restricted-imports -- raw token read kept until this site is moved to theme.semantics
import { DS_COLOR, DS_WIDTH } from '@calm/evexia-design-tokens';
// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/lightbulb-with-circle.svg';
import { Box, Theme } from '@rhg/libs/material';

const styleIcon = {
    width: DS_WIDTH.LOGO_SMALL,
    height: DS_WIDTH.LOGO_SMALL,
};

const styleIconContainer = {
    borderRadius: '50%',
    p: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: (theme: Theme) =>
        theme.palette.mode === 'light' ? 'info.light' : DS_COLOR.BLACK_20P,
};

export const LightbulbWithCircle = (props: SvgIconProps) => (
    <Box sx={styleIconContainer}>
        <SvgIcon sx={styleIcon} component={Svg} inheritViewBox {...props} />
    </Box>
);
